import { render, staticRenderFns } from "./load-cell.vue?vue&type=template&id=8fb0dd62&scoped=true&"
import script from "./load-cell.vue?vue&type=script&lang=js&"
export * from "./load-cell.vue?vue&type=script&lang=js&"
import style0 from "./load-cell.vue?vue&type=style&index=0&id=8fb0dd62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb0dd62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fb0dd62')) {
      api.createRecord('8fb0dd62', component.options)
    } else {
      api.reload('8fb0dd62', component.options)
    }
    module.hot.accept("./load-cell.vue?vue&type=template&id=8fb0dd62&scoped=true&", function () {
      api.rerender('8fb0dd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/load-cell.vue"
export default component.exports